import { createBaseFilter } from "@circle-react-shared/MemberFilters/types";

import { toQueryString } from "./toQueryString";

type Params = Record<string, any>;

interface SpaceGroup {
  params?: Params;
}

interface SpaceGroupId extends SpaceGroup {
  spaceGroupId?: string;
}

interface SpaceGroupSlug extends SpaceGroup {
  spaceGroupSlug?: string;
}

export const spaceGroupPaths = {
  new: ({ params = {} }: SpaceGroup) =>
    `/space_groups/new/?${toQueryString(params)}`,
  show: ({ spaceGroupSlug, params = {} }: SpaceGroupSlug) =>
    `/s/${spaceGroupSlug}/?${toQueryString(params)}`,
  members: ({ spaceGroupSlug }: SpaceGroupSlug) =>
    `/members?${toQueryString({
      filters: [
        createBaseFilter({
          id: "space_groups",
          key: "space_groups",
          value: spaceGroupSlug,
        }),
      ],
    })}`,
  toggleVisibility: ({ spaceGroupId, params = {} }: SpaceGroupId) =>
    `/space_groups/${spaceGroupId}/toggle_visibility?${toQueryString(params)}`,
};
